var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{staticClass:"mt-5 py-1 pr-5",attrs:{"row":"","dense":""},on:{"change":_vm.onChange},model:{value:(_vm.radioGroup),callback:function ($$v) {_vm.radioGroup=$$v},expression:"radioGroup"}},[_c('v-radio',{attrs:{"label":"PDF","value":"pdf"}}),_c('v-radio',{attrs:{"label":"XLS","value":"xlsx"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }